module.exports = __webpack_public_path__ + "static/media/mobileScreenshot04.0ea3e193.jpg";